/* @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { CustomerLogoBanner } from '@slite/components'

import ComplianceLogos from '../../assets/compliance-logos.svg'
import { Button } from '../../components/Button/Button'
import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'
import { useRoutes } from '../../routes'
import { SMALL_BREAKPOINT } from '../../utils/breakpoints'
import { HeroScan } from './HeroScan'
import { SliteAgentIcon } from './SliteAgentIcon'

const subtitleCss = css`
  max-width: 720px;
`

const complianceLogosCss = css`
  max-width: 200px;
`

const customersCss = css`
  margin-top: 80px;
`

const logoBannerCss = css`
  max-width: 1100px;
`

export function SectionAgentHero() {
  const routes = useRoutes()

  return (
    <Section
      isFirstSection
      containerTopPadding={96}
      containerBottomPadding={80}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <HeroScan />
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto position-relative'
        )}
      >
        <SliteAgentIcon size={80} className="margin-bottom-24" />
        <WebsiteText
          variant="heroTitle"
          className="text-align-center position-relative"
          css={css`
            && {
              font-size: 64px;
              max-width: 900px;
              margin-left: auto;
              margin-right: auto;
              line-height: 1.2;

              @media (max-width: ${SMALL_BREAKPOINT - 1}px) {
                font-size: var(--font-size-1);
              }
            }
          `}
        >
          <FormattedMessage
            id="agent.hero.title"
            defaultMessage="Your AI agent for trusted company knowledge"
          />
        </WebsiteText>
        <WebsiteText
          variant="body-lg"
          htmlTag="p"
          className="margin-top-16 padding-top-24"
          css={subtitleCss}
        >
          <FormattedMessage
            id="agent.hero.subtitle"
            defaultMessage="Scale AI across your company with Slite agent that delivers trusted answers, drafts documentation and proposes updates for your team to approve."
          />
        </WebsiteText>
        <div
          className="margin-top-32 flexbox flexbox-align-center flexbox-gap-12"
          css={css`
            @media (max-width: ${SMALL_BREAKPOINT - 1}px) {
              flex-direction: column;
              gap: 16px;
            }
          `}
        >
          <Button variant="primary" size="huge" href={routes.bookDemo()}>
            <FormattedMessage
              id="agent.hero.cta"
              defaultMessage="Book a demo"
            />
          </Button>
          <img
            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
            alt="SOC 2, HIPAA and GDPR compliance logos"
            src={ComplianceLogos}
            css={complianceLogosCss}
          />
        </div>
      </div>

      <div className="position-relative" css={customersCss}>
        <p className="text-align-center font-size-4 line-height-large shade-10">
          <FormattedMessage
            id="agent.hero.customer.caption"
            defaultMessage="3,000+ leading companies trust Slite as their single source of truth."
          />
        </p>
        <div className="margin-left-auto margin-right-auto" css={logoBannerCss}>
          <CustomerLogoBanner />
        </div>
      </div>
    </Section>
  )
}
